import type { IFilter } from 'src/components/price-list/types';
import { FilterType } from 'src/components/price-list/types';
import type { ProductOffer, ProductMainOffer } from 'src/types';

export const getApplicableFilters = (
  filters: IFilter[],
  offers: ProductMainOffer[],
  allOffersWithActiveAdditives: ProductMainOffer[]
): IFilter[] => {
  const hasAuthorizedInOffers = getHasAuthorizedInOffers(
    allOffersWithActiveAdditives
  );
  const hasInternationalOffers = getHasInternationalOffers(offers);
  const hasNotAvailableOffers = getHasNotAvailableOffers(offers);
  const updatedFilters = filters.filter(
    filter =>
      (filter.type !== FilterType.AUTHORIZED_DEALER || hasAuthorizedInOffers) &&
      (filter.type !== FilterType.INTERNATIONAL || hasInternationalOffers) &&
      (filter.type !== FilterType.NOT_FOR_SALE || hasNotAvailableOffers)
  );
  return updatedFilters;
};

const getHasAuthorizedInOffers = (offers: ProductMainOffer[]): boolean =>
  offers.some(offer => offer.authorizedDealer);

const getHasInternationalOffers = (offers: ProductMainOffer[]): boolean => {
  return offers.some(
    offer => !offer.primaryMarket || getHasInternationalAlternatives(offer)
  );
};

const getHasInternationalAlternatives = (offer: ProductMainOffer): boolean => {
  const alternativeOffers = (offer.alternativeOffers ?? []) as ProductOffer[];
  if (alternativeOffers.length === 0) {
    return false;
  }
  return alternativeOffers.some(altOffer => !altOffer.primaryMarket);
};

const getHasNotAvailableOffers = (offers: ProductMainOffer[]): boolean => {
  return offers.some(
    offer =>
      offer.availability?.condition === 'NotAvailableForOrder' ||
      getHasNotAvailableAlternatives(offer)
  );
};

const getHasNotAvailableAlternatives = (offer: ProductMainOffer): boolean => {
  const alternativeOffers = (offer.alternativeOffers ?? []) as ProductOffer[];
  if (alternativeOffers.length === 0) {
    return false;
  }
  return alternativeOffers.some(
    altOffer => altOffer.availability?.condition === 'NotAvailableForOrder'
  );
};
